import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {IExpressOrder} from 'plugins/modules/filter/types';
import React, {FC} from 'react';
import style from './style.module.scss';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';
import cs from 'classnames';

interface IProps {
    wineShop: IExpressOrder;
}

export const Winery: FC<IProps> = ({wineShop}) => {
    const {isActive: isAbExpressOrder} = useGetAbExpressOrder();

    return (
        <div className={cs(style.main, {[style.new]: isAbExpressOrder})}>
            <Typography variant={'label-12-r'}>{wineShop.titleVinoteki}</Typography>
            {!isAbExpressOrder && <Icon className={style.icon} icon={'arrow-new'} />}
        </div>
    );
};
